import Konva from 'konva';
import { Rect } from 'react-konva';
import { Color, DateNumber, DateRange } from 'types/global';
import { GraphStyle } from '../types';
import { xFromTimeStyled } from '../utils';



function DateRangeCmp({
	start,
	range,
	height,
	style,
	styleRange,
	...props
}: DateRangeCmpProps) {

	if (!range || !range.start) return null

	const xFromTime = xFromTimeStyled(style, start)
	const rangeStart = range.start
	const rangeEnd = range.end ?? range.start
	styleRange = {
		fill: style.primaryColor + "1a" as Color, //"rgba(255,193,7,.1)"
		stroke: style.primaryColor + "80" as Color, //"rgba(255,193,7,.5)"
		mUp: 0, mBottom: 0, mLeft: 0, mRight: 0,
		strokeWidth: 1,
		dash: null,
		...styleRange
	}

	return (
		<Rect
			x={xFromTime(rangeStart) + styleRange.mLeft}
			y={style.space.y + styleRange.mUp}
			height={height - styleRange.mUp - styleRange.mBottom}
			width={xFromTime(rangeEnd) - xFromTime(rangeStart) + style.space.x - styleRange.mLeft - styleRange.mRight}
			fill={styleRange.fill}
			stroke={styleRange.stroke}
			dash={styleRange.dash}
			strokeWidth={styleRange.strokeWidth}
			listening={false}
			{...props}
		/>
	)
}

export default DateRangeCmp

type DateRangeCmpProps = {
	start: DateNumber,
	range: DateRange,
	height: number,
	style: GraphStyle,
	styleRange?: DateRangeStyle,
} & Konva.NodeConfig

export interface DateRangeStyle {
	fill?: Color,
	stroke?: Color,
	mUp?: number,
	mBottom?: number,
	mRight?: number,
	mLeft?: number,
	strokeWidth?: number,
	dash?: number[],
}
